import http from "../../../http-commonv2";

const list = () => {
  return http.get(`/api/v2/management/apiToken`);
};

const create = (data) => {
  return http.post(`/api/v2/management/apiToken`, data);
};

const deleteById = (id) => {
  return http.delete(`/api/v2/management/apiToken?id=${id}`);
};

const ApiTokenService = {
  list,
  create,
  deleteById,
};

export default ApiTokenService;
